import { post,get,postJson,deleteApi,put} from '../axios'

const RESOURCE_BASE_PATH = '/refundReminderConfig';

/**
 * 退款任务管理列表
 */
// 类型标志，1申请退款，2、同意退款，3、拒绝退款 4、退款成功
export const getRefundReminderConfigPage = p => {
    return get(`${RESOURCE_BASE_PATH}/getRefundReminderConfigPage`,p);
}

/**
 * 更新任务开启/优先级
 */
export const setOpenState = p => {
    return post(`${RESOURCE_BASE_PATH}/openState`,p);
}

/**
 * 新建/更新 任务
 */
export const updateAndSave = p => {
    return postJson(`${RESOURCE_BASE_PATH}/updateAndSave`,p);
}


/**删除任务
 */
export const delOrdersCareRefund = id => {
    return deleteApi(`${RESOURCE_BASE_PATH}/delete/${id}`);
}

/**任务详情
 */
export const OrdersCareRefundInfo = p => {
    return get(`${RESOURCE_BASE_PATH}/get`,p);
}

/**添加地区信息
 */
export const addRefundProvinceConfig = p => {
    return put(`${RESOURCE_BASE_PATH}/addRefundProvinceConfig`,p);
}